module.exports = {

    defaultIcon:        'file_text',

    icon: {
        // note:           'ii5-note',
        file_text:      'ii5-file-text',
        wiki:           'ii5-wiki',
        information:    'ii5-information',

        book:           'ii5-book',
        brand:          'ii5-brand',
        assets:         'ii5-assets',
        file_binary:    'ii5-file-binary',
        file_code:      'ii5-file-code',
        file_contact:   'ii5-file-contact',
        globe:          'ii5-globe',
        graduation:     'ii5-graduation',
        graph:          'ii5-graph',
        image:          'ii5-image',
        mail_black:     'ii5-mail-black',
        mail_read:      'ii5-mail-read',
        calendar:       'ii5-calendar'
    },

    access: {
        LIMITED: 1,
        STANDARD: 2,
        FULL: 3,
        NOT_SHARED: 4,
    },

    accessList: {
        1: 'Limited',
        2: 'Standard',
        3: 'Full',
        4: 'Not shared',
    },
};